import * as React from "react";
import { NavMenuOption, PageLayout } from "components/PageLayout/PageLayout";
import { BreadcrumbItem } from "components/Breadcrumbs/Breadcrumbs";
import Box from "@mui/material/Box";
import { ClientContactMtRequestsTable } from "./ClientContactMtRequestsTable/ClientContactMtRequestsTable";
import { Typography } from "@mui/material";
import { useSessionStorage } from "usehooks-ts";
import { SelectOption } from "@mui/base";
import { Filter } from "./Filter/Filter";
import { ExportAnalyticsButton } from "./ExportAnalyticsButton/ExportAnalyticsButton";

const breadcrumbs: BreadcrumbItem[] = [
  {
    path: "/analytics",
    label: "Analytics"
  },
  {
    path: "/analytics/machineTranslation",
    label: "Machine Translation Requests by Client Contact",
    active: true
  }
];

const MT_ANALYTICS_PAGE_SESSION_STATE_VAR_NAME = "mtAnalyticsPageStateV1";

const MachineTranslationAnalyticsPage: React.FC = () => {
  const now = new Date();
  const [from, setFrom] = React.useState<Date>(new Date(now.getTime() - 30 * 24 * 60 * 60 * 1000));
  const [to, setTo] = React.useState<Date>(now);
  const [isSearching, setIsSearching] = React.useState(false);
  const [client, setClient] = useSessionStorage<SelectOption<string>>(MT_ANALYTICS_PAGE_SESSION_STATE_VAR_NAME, {
    label: "",
    value: ""
  });

  const onFilterChange = React.useCallback(
    (newFrom: Date, newTo: Date, newClient: SelectOption<string>) => {
      setFrom(newFrom);
      setTo(newTo);
      setClient(newClient);
    },
    [setClient]
  );

  React.useEffect(() => {
    if (!client.value) {
      setIsSearching(false);
    }
  }, [client.value]);

  return (
    <PageLayout
      selectedNavMenu={NavMenuOption.ANALYTICS}
      title={<Typography variant="h6">Machine Translation Requests by Client Contact</Typography>}
      breadcrumbs={breadcrumbs}
    >
      <Filter from={from} to={to} client={client} isSearching={isSearching} onChange={onFilterChange} />

      {client.value && (
        <Box>
          <Box textAlign="right">
            <ExportAnalyticsButton clientId={client.value} from={from} to={to} />
          </Box>
          <ClientContactMtRequestsTable
            clientId={client.value}
            from={from}
            to={to}
            onLoadingStateChange={setIsSearching}
          />
        </Box>
      )}
    </PageLayout>
  );
};

export { MachineTranslationAnalyticsPage };
